import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

const PdfViewerModal = ({ pdfUrl }) => {
  const [show, setShow] = useState(false);

  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <>
      <button className="btn-outline" onClick={handleOpen}>
        FULL ROADMAP
      </button>

      <Modal show={show} onHide={handleClose} size="xl" centered className="pdf-modal">
        {/* <Modal.Header closeButton>
          <Modal.Title>PDF Preview</Modal.Title>
        </Modal.Header> */}
        <Modal.Body style={{ height: "80vh" }}>
          <iframe
            src={pdfUrl}
            title="PDF Document"
            width="100%"
            height="100%"
            style={{ border: "none" }}
          ></iframe>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PdfViewerModal;
